import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Icon from 'components/Icon';

const Container = styled.div`
	background-color: rgb(74,144,226,0.05);
`;

const Label = styled.div`
	height: 32px;
	padding: 4px 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	color: #9B9B9B;
	font-size: 14px;
`;

const Content = styled.div`
	margin: 16px 0 0 0;
	display: ${props => props.open ? 'block' : 'none'};
`;

class Accordion extends React.Component {
	state = {
	  open: false,
	}

	openHandler = () => this.setState({ open: !this.state.open });

	render() {
	  return (
	    <Container>
	      <Label onClick={this.openHandler}>
	        { this.props.label }
	        <Icon icon={ this.state.open ? 'cheveron-up' : 'cheveron-down'} />
	      </Label>
	      <Content open={this.state.open}>
	        { this.props.children }
	      </Content>
	    </Container>
	  )
	}
}

Accordion.propTypes = {
	label: PropTypes.string,
	children: PropTypes.any,
}

export default Accordion
